import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { MenuModel } from '../models/menu.model';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  })
};

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  
  constructor(private http: HttpClient) { }

  getMenu(): Observable<MenuModel> {
    return this.http.get<MenuModel>('../assets/menu.config.json', httpOptions);
  }
}
